<template>
  <div>
    <div class="version5-head">
      <LayoutHeadBanner
        v-if="$store.state.selected_menu"
        :itemData="$store.state.selected_menu"
      />
    </div>
    <Breadcrumb />

    <Overview
      v-for="(item, index) in _.get(
        $store.state.current_content,
        'secondary.programContent.data'
      )"
      v-if="
        _.get(
          $store.state.current_content,
          'secondary.programContent.conf.enabled'
        ) == 1
      "
      :itemData="item"
      :direction="index % 2 == 1 ? 'reverse' : 'standard'"
      :key="index"
    />
    <intersect @enter="animate = true">
      <section class="container business-model fadeUp" :class="animate ? 'animate' : '' " v-if="_.get($store.state.current_content,'secondary.AdditionalPage1.conf.enabled') == 1 || _.get($store.state.current_content,'secondary.AdditionalPage2.conf.enabled') == 1">
        <div class="overview-container row-standard flex-box" v-if="_.get($store.state.current_content,'secondary.AdditionalPage1.conf.enabled') == 1">
          <div class="overview-left">
            <div class="img-box">
              <picture>
                <source
                  media="(max-width: 767px)"
                  :srcset="_.get($store.state.current_content,'secondary.AdditionalPage1.data.0.images.0.devices.mobile')"

                />
                <source
                  media="(max-width: 1023px)"
                  :srcset="_.get($store.state.current_content,'secondary.AdditionalPage1.data.0.images.0.devices.tablet')"

                />
                <img
                  src="@/assets/img/img(33).jpg"
                  :src="_.get($store.state.current_content,'secondary.AdditionalPage1.data.0.images.0.devices.desktop')"
                  class="img-absolute br-12"
                  alt
                />
              </picture>
            </div>
          </div>
          <div class="overview-right">
            <h2 class="main-title">
              {{
                _.get(
                  this.$store.state.current_content,
                  "secondary.AdditionalPage1.data.0.title"
                )
              }}
            </h2>
            <div
              class="text"
              v-html="
                _.get(
                  this.$store.state.current_content,
                  'secondary.AdditionalPage1.data.0.content.tabs.0.content'
                )
              "
            ></div>
          </div>
        </div>
        <div
          class="overview-container row-standard flex-box"
          v-if="
            _.get(
              this.$store.state.current_content,
              'secondary.AdditionalPage2.conf.enabled'
            ) == 1
          "
        >
          <div class="overview-left">
            <h3 class="other-title">
              {{
                _.get(
                  this.$store.state.current_content,
                  "secondary.AdditionalPage2.data.0.title"
                )
              }}
            </h3>
            <div
              class="text"
              v-html="
                _.get(
                  this.$store.state.current_content,
                  'secondary.AdditionalPage2.data.0.content.tabs.0.content'
                )
              "
            ></div>
          </div>
          <div class="overview-right">
            <div class="img-box">
              <picture>
                <img
                  :src="
                    _.get(
                      $store.state.current_content.secondary.AdditionalPage2.data,
                      [
                        0,
                        'images',
                        Object.keys(
                          $store.state.current_content.secondary.AdditionalPage2
                            .data[0].images
                        )[0],
                        'url',
                      ]
                    )
                  "
                  class="img-absolute br-12"
                  alt
                />
              </picture>
            </div>
          </div>
        </div>
      </section>
    </intersect>

    <NewsAndMedia
      v-if="
        _.get(
          this.$store.state.current_content,
          'secondary.NewsAndMedia.conf.enabled'
        ) == 1
      "
      :itemData="
        _.get(this.$store.state.current_content, 'secondary.NewsAndMedia')
      "
    />

    <Partners
      v-if="
        _.get(
          this.$store.state.current_content,
          'secondary.Partners.conf.enabled'
        ) == 1
      "
      :itemData="_.get(this.$store.state.current_content, 'secondary.Partners')"
    />
  </div>
</template>
<script>
import LayoutHeadBanner from "@/components/LayoutHeadBanner";
import Breadcrumb from "@/components/Breadcrumb";
import NewsAndMedia from "@/components/NewsAndMedia";
import Partners from "@/components/Partners";
import Overview from "@/components/Overview";
import Intersect from 'vue-intersect'

export default {
  components: {
    LayoutHeadBanner,
    Breadcrumb,
    NewsAndMedia,
    Partners,
    Overview,
    Intersect
  },
  data(){
    return{
      animate: false,
    }
  }

  // computed: {
  //     getAdditionalPage1Title(){
  //         let data = _.get(this.$store.state.current_content,'secondary.AdditionalPage1.data.title');
  //         if(data !== undefined && data.length > 0){
  //             return data;
  //         }
  //     },
  //     getAdditionalPage1Content(){
  //         let data = _.get(this.$store.state.current_content,'secondary.AdditionalPage1.data[0].content.tabs[0].content');
  //         if(data !== undefined && data.length > 0){
  //             return data;
  //         }
  //     },

  //     getStrategyContent(){
  //         let data = _.get(this.$store.state.current_content,'secondary.AdditionalPage2.data[0].content.tabs[0].content');
  //         if(data !== undefined && data.length > 0){
  //             return data;
  //         }
  //     },

  //     getStrategyTitle(){
  //         let data = _.get(this.$store.state.current_content,'secondary.AdditionalPage2.data[0].title');
  //         if(data !== undefined && data.length > 0){
  //             return data;
  //         }
  //     },

  // }
};
</script>


<style>
.text .table {
  margin: 0px;
}
.text td {
  padding: 0px;
  vertical-align: top;
}
.text tr {
  display: flex;
  margin-bottom: 60px;
}
.text td:nth-child(odd) {
  padding-right: 25px;
}
.text td:nth-child(even) {
  padding-left: 25px;
}
.text td h2 {
  font-size: 55px;
  line-height: 65px;
  font-family: "NotoSansGeorgian-SemiBold", "NotoSans-SemiBold";
  margin-bottom: 18px;
}
.text td h3 {
  font-size: 34px;
  line-height: 45px;
  font-family: "NotoSansGeorgian-SemiBold", "NotoSans-SemiBold";
  margin-bottom: 18px;
}
.text td h4 {
  font-size: 21px;
  line-height: 28px;
  font-family: "NotoSansGeorgian-SemiBold", "NotoSans-SemiBold";
  margin-bottom: 18px;
}
@media (max-width: 1679px) {
  .text td:nth-child(odd) {
    padding-right: 22.5px;
  }
  .text td:nth-child(even) {
    padding-left: 22.5px;
  }
  .text tr {
    display: flex;
    margin-bottom: 55px;
  }
}
@media (max-width: 1439px) {
  .text td h3 {
    font-size: 25px;
    line-height: 35px;
    margin-bottom: 20px;
  }
  .text td h2 {
    font-size: 34px;
    line-height: 45px;
  }
}
@media (max-width: 1365px) {
  .text td:nth-child(odd) {
    padding-right: 10px;
  }
  .text td:nth-child(even) {
    padding-left: 10px;
  }
  .text tr {
    display: flex;
    margin-bottom: 34px;
  }
  .text td h3 {
    font-size: 21px;
    line-height: 25px;
  }
}

@media (max-width: 1023px) {
  .text tr {
    display: flex;
    margin-bottom: 54px;
  }
  .text td h2 {
    font-size: 25px;
    line-height: 35px;
  }
}
@media (max-width: 767px) {
  .text tr {
    flex-direction: column;
    margin-bottom: 0;
  }
  .text td:nth-child(odd),
  .text td:nth-child(even) {
    padding: 0;
    margin-bottom: 30px;
  }
  .text td h4 {
    font-size: 16px;
    line-height: 20px;
  }
}
</style>